export default __webpack_public_path__ + "static/media/151-gardener.39381591.png";